import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Button,
  Paper
} from '@mui/material';
import { FaceBookIcon, IdentityIcon, InstagramIcon, LinkedinIcon, SelfieIcon, VerifiIcon, XIcon } from '../../../icons';
 


const VerificationSection = ({ showOnlyVerified = false, className, memberData }) => {
  const verificationItems = [
    { label: 'Instagram', icon: <InstagramIcon style={{ width: 23, height: 22, fill: '#E4405F' }} />, verified: memberData?.isInstagramVerified },
    { label: 'LinkedIn', icon: <LinkedinIcon style={{ width: 23, height: 22, fill: '#0077B5' }} />, verified: memberData?.isLinkedinVerified },
    { label: 'Facebook', icon: <FaceBookIcon sx={{ color: '#1877F2' }} />, verified: memberData?.isFacebookVerified },
    { label: 'Identity', icon: <IdentityIcon sx={{ color: '#D9534F' }} />, verified: memberData?.isIdVerified },
    { label: 'Selfie', icon: <SelfieIcon sx={{ color: '#F47C7C' }} />, verified: memberData?.isProfileVerified },
    { label: 'X', icon: <XIcon sx={{ color: '#F47C7C' }} />, verified: memberData?.isTwitterVerified },
  ];
  const itemsToShow = showOnlyVerified
    ? verificationItems.filter((item) => (showOnlyVerified ? item.verified : true))
    : verificationItems;

  return (
    <Box className={className} sx={{ backgroundColor: '#FFFFFF', padding: { xs: '16px', lg: '24px 20px' }, borderRadius: 2, my: { xs: '10px', lg: '20px' } }}>
      <Typography
        className="FontIvypresto"
        fontWeight={600}
        sx={{ fontSize: { xs: '20px', xl: '20px' }, color: '#6A513E', marginBottom: 1 }}
      >
        Verification
      </Typography>

      <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden', border: 'none' }}>
        <List
          disablePadding
          sx={{
            border: 'none',
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(1, 1fr)' },
            gap: '8px',
          }}
        >
          {itemsToShow.map((item, index) => (
            <ListItem
              key={index}
              sx={{
                bgcolor: '#F9F5F2',
                px: 2,
                display: 'flex',
                borderRadius: '8px',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: { xs: 'center', sm: 'space-between' },
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: 'center',
                  gap: { xs: 0.5, sm: 1.5 },
                  pt: { xs: '8px', sm: 0 },
                }}
              >
                <ListItemIcon sx={{ minWidth: 'auto' }}>{item.icon}</ListItemIcon>
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{ fontWeight: 500, fontSize: { xs: '12px', sm: '14px' } }}
                />
              </Box>

              {item.verified ? (
                <IconButton edge="end" aria-label="verified" sx={{ pt: { xs: '0', sm: '8px' } }}>
                  <VerifiIcon />
                </IconButton>
              ) : (
                !showOnlyVerified && (
                  <Button
                    variant="contained"
                    size="small"
                    sx={{
                      mt: { xs: '4px', sm: 0 },
                      fontSize: '11px',
                      textTransform: 'none',
                      borderRadius: '20px',
                      fontStyle: 'italic',
                      bgcolor: '#0D99FF',
                      ':hover': { bgcolor: '#4e3a2d' },
                    }}
                  >
                    Verify Now
                  </Button>
                )
              )}
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
};

export default VerificationSection;
